import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { buildLoginPath } from '../utils/authRedirect';

const RoleProtectedRoute = ({ children, allowedRoles = ['admin', 'campus_admin', 'superuser', 'finance'] }) => {
    const { user, isAuthenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) return <div className="p-xl text-center">Verifying permissions...</div>;

    if (!isAuthenticated) {
        return <Navigate to={buildLoginPath(location)} replace />;
    }

    const hasRole = allowedRoles.includes(user?.user_type) || user?.is_staff || user?.is_superuser;

    if (!hasRole) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default RoleProtectedRoute;
